export const DangerZoneSection = {
  hide: (el) => !el.hasProjectPermission('iam'),
  CardContent: {
    flow: 'y',
    align: 'start',
    gap: 'C1',
    Hgrpup: {
      H: {
        color: 'title',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        text: '{{ editor.dangerZone.title | polyglot }}'
      },
      P: {
        margin: '0',
        text: '{{ editor.dangerZone.hint | polyglot }}'
      }
    },
    ContinueButton: {
      text: '{{ editor.dangerZone.action | polyglot }}',
      theme: null,
      // Outlined button (design-direction.md §8 ban list), and the '2px' was
      // a raw width on top of that. This is a destructive action, so the fix
      // is the semantic danger tint (DESIGN_LANGUAGE §4.2: status fills are
      // tints, `red.1` fill + `red` ink), not a stroke.
      round: 'radiusPill',
      cursor: 'pointer',
      background: 'red.1',
      color: 'red',
      ':hover': { background: 'red.15' },
      onClick: async (ev, el, st) => {
        // Double confirmation is not recommended because it can be frustrating for users.
        if (
          !window.confirm(
            `Are you sure you want to delete this project? This action cannot be undone.`
          )
        ) {
          return
        }

        if (
          !window.confirm(
            `Please confirm once more that you want to permanently delete "${st.projectName}".`
          )
        ) {
          return
        }

        const { projectId } = st

        try {
          await el.sdk.removeProject(projectId) // removeProject does not return anything
          el.call('openNotification', {
            title: el.call('polyglot', 'editor.dangerZone.deleted.title'),
            message: el.call('polyglot', 'editor.dangerZone.deleted.message'),
            type: 'success'
          })
          setTimeout(() => {
            // SPA-nav to /dashboard after project removal. If the router
            // ever fails to apply the new route, fall back to a full
            // navigation so the user isn't stranded on the now-deleted
            // project's settings page.
            try {
              el.router('/', el.getRoot())
            } catch (_) {
              if (typeof window !== 'undefined') window.location.href = '/'
            }
          }, 1000)
        } catch (error) {
          el.call('openNotification', {
            title: el.call('polyglot', 'editor.dangerZone.failed.title'),
            message: el
              .call('polyglot', 'editor.dangerZone.failed.message')
              .replace(
                '{error}',
                error.message || el.call('polyglot', 'editor.dangerZone.failedFallback')
              ),
            type: 'error'
          })
        }
      }
    }
  },
  flow: 'y',
  width: '100%',
  maxWidth: 'I2',
  gap: 'B1',
  align: 'flex-start',
  position: 'relative',
  margin: 'C1 0'
}
